export function mapEnum(enumerable: any, fn: Function): any[] {
    // get all the members of the enum
    let enumMembers: any[] = Object.keys(enumerable).map(key => {
        return enumerable[key];
    });

    // now map through the enum values
    return enumMembers.map(m => fn(m));
}

export const diffObjects = (original: any, modified: any, alwaysInclude: string[] = []): any => {
    if (original === modified) {
        return undefined;
    }

    if (typeof original !== "object" || typeof modified !== "object") {
        return undefined;
    }

    const changedValues: any = {};

    for (const [key, value] of Object.entries(modified)) {
        if (Array.isArray(value)) {
            if (JSON.stringify(original[key]) !== JSON.stringify(value)) {
                changedValues[key] = value;
            }
        } else if (typeof value === "object") {
            const nestedChanges = diffObjects(original[key], modified[key], alwaysInclude);

            if (nestedChanges !== undefined) {
                changedValues[key] = nestedChanges;
            }
        } else if (original[key] !== modified[key]) {
            changedValues[key] = modified[key];
        }
    }

    if (alwaysInclude?.length > 0) {
        for (const key of alwaysInclude) {
            if (original.hasOwnProperty(key)) {
                changedValues[key] = original[key];
            }
        }
    }

    return Object.keys(changedValues).length > 0 ? changedValues : undefined;
};
